import { render, staticRenderFns } from "./Pend.vue?vue&type=template&id=cc8b53be&scoped=true&"
import script from "./Pend.vue?vue&type=script&lang=js&"
export * from "./Pend.vue?vue&type=script&lang=js&"
import style0 from "./Pend.vue?vue&type=style&index=0&id=cc8b53be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b53be",
  null
  
)

export default component.exports